module.exports = __webpack_public_path__ + "static/media/target.23244242.svg";